import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import SchemaAnalyticsPage from "../data-structure-analytics/ui/SchemaAnalyticsPage";

/** Schema relations graph — under Data Pipeline; previously an AI Context tab. */
const SchemaRelations = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <PageContentShell>
      <SchemaAnalyticsPage />
    </PageContentShell>
  </DashboardLayout>
);

export default SchemaRelations;
